import React from 'react'
import { Body, Box } from '../layout'
import './Checkbox.scss'

export const Checkbox = ({ name, label }) => (
  <label className="checkbox">
    <input
      type="checkbox"
      name={name}
      required
    />
    <Box className="checkmark" />
    <Box ml={8}>
      <Body small>
        {label}
      </Body>
    </Box>
  </label>
)